import { render, staticRenderFns } from "./ErrorRequest.vue?vue&type=template&id=636a00de&"
import script from "./ErrorRequest.vue?vue&type=script&lang=js&"
export * from "./ErrorRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports